import React, { useState, useEffect } from 'react';
import { Icon, Timeline, Tag, Modal, Popover } from '@b-design/fusion';
import Button from '@/components/Button';
import { Col, Row } from 'antd';
import $i18n from '@/i18n';
import ColorTags from '@/components/ColorTags';
import { getApprovalsResult } from '@/utils/status';
import Requests from '@/services/request';
import CommonHeader from '@/components/CommonHeader';
import { getQueryStringArgs } from '@/utils/url-parse';
import { formatTime } from '@/utils';
import QRCode from '@/components/QRCode'

import './index.less';
import DefaultAppIcon from '@/components/DefaultAppIcon';

const ReleaseResult: React.FC = () => {
  const { approveId, appId, channelCode, version, spaceId } = getQueryStringArgs();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [versionDetail, setVersionDetail] = useState<any>({});

  // 获取详情数据
  const initDataSource = async () => {
    const data = await Requests.get('/rest/intercnn/approve/detail', {
      approveId,
    });
    if (data) {
      setVersionDetail(data);
    }
  };

  useEffect(() => {
    initDataSource();
  }, []);

  const handleOk = async () => {
    const data = await Requests.post('/rest/intercnn/approve/process', {
      approveId,
      approveAction: 'WITHDRAW',
      approveOpinion: 'WITHDRAW',
    });
    if (data) {
      setIsModalVisible(false);
      await initDataSource();
    }
  };

  const breadcrumbConfig = [
    {
      key: 'miniapp',
      breadcrumbName: $i18n.get({ id: 'aopf.pages.miniapp.ApplicationList', dm: '应用列表' }),
      path: `/miniapp`,
    },
    {
      key: 'details',
      breadcrumbName: $i18n.get({ id: 'aopf.pages.miniapp.ApplicationDetails', dm: '应用详情' }),
    },
    {
      key: 'versions',
      breadcrumbName: $i18n.get({ id: 'aopf.pages.miniapp.ApplicationVersions', dm: '应用版本' }),
    },
  ];

  return (
    <div className="miniapp-status">
      <CommonHeader
        title={versionDetail?.extInfo?.description?.name}
        backTo={`/miniapp/version?spaceId=${spaceId || ''}&appId=${appId}&channelCode=${channelCode}&version=${version}`}
        breadcrumbs={breadcrumbConfig}
      />
      <div className="status-container">
        <div className="status-title">
          <Row>
            <Col span={6}>
              <div className="info-one">
                <div className="info-one-title">
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.version.info.title.Status',
                    dm: '状态',
                  })}
                </div>
                <div className="info-one-text">
                  {versionDetail?.approveAction ? (
                    <ColorTags {...getApprovalsResult(versionDetail?.approveAction)} />
                  ) : (
                    <ColorTags {...getApprovalsResult(versionDetail?.status)} />
                  )}
                </div>
              </div>
            </Col>
            <Col span={6}>
              <div className="info-other">
                <div className="info-other-title">
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.version.info.process.Applicant',
                    dm: '申请人',
                  })}
                </div>
                <div className="info-other-text">{versionDetail?.createName}</div>
              </div>
            </Col>
            <Col span={6}>
              <div className="info-time">
                <div className="info-time-title">
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.version.info.process.Time',
                    dm: '时间',
                  })}
                </div>
                <div className="info-time-text">{formatTime(versionDetail?.gmtCreate)}</div>
              </div>
            </Col>
          </Row>
        </div>
        <div className="container-bottom">
          <div className="container-progress">
            <div className="progress-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.process.Approvals.Process',
                dm: '审批流程',
              })}
            </div>
            <Timeline>
              <Timeline.Item
                title={
                  <div className="progress-item">
                    <span>{versionDetail?.createName}</span>
                    <span>{formatTime(versionDetail?.gmtCreate)}</span>
                  </div>
                }
                content={
                  <div className="progress-content">
                    <div className="progress-dec">
                      {$i18n.get({
                        id: 'aopf.pages.miniapp.version.info.process.Submit.Release.Application',
                        dm: '提交应用程序版本',
                      })}
                    </div>
                    <Tag data-square>
                      {$i18n.get({
                        id: 'aopf.pages.miniapp.version.info.process.Application',
                        dm: '申请',
                      })}
                    </Tag>
                    <span className="progress-content-text">
                      {$i18n.get({
                        id: 'aopf.pages.miniapp.version.info.process.Additional.Information',
                        dm: '申请发布新版本',
                      })}
                    </span>
                  </div>
                }
              />
              {versionDetail?.status !== 'PROCESSING' ? (
                <Timeline.Item
                  title={
                    <div className="progress-item">
                      <span>{versionDetail?.modifiedName}</span>
                      <span>{formatTime(versionDetail?.gmtModified)}</span>
                    </div>
                  }
                  content={
                    <div className="progress-content">
                      {versionDetail?.approveAction === 'PASSED' ? (
                        <div>
                          <div className="progress-dec">
                            {$i18n.get({
                              id: 'aopf.pages.miniapp.version.info.process.Review.Application',
                              dm: '审查申请',
                            })}
                          </div>
                          <Tag data-square data-tag-color="cold-green">
                            {$i18n.get({
                              id: 'aopf.pages.miniapp.version.info.process.Passed',
                              dm: '通过',
                            })}
                          </Tag>
                        </div>
                      ) : versionDetail?.approveAction === 'WITHDRAW' ? (
                        <>
                          <div className="progress-dec">
                            {$i18n.get({
                              id: 'aopf.pages.miniapp.version.info.process.Review.WithDraw',
                              dm: '撤回发布',
                            })}
                          </div>
                          <Tag data-square color="#FFF4ED" className="tag-withdraw">
                            {$i18n.get({
                              id: 'aopf.pages.miniapp.version.info.process.Withdraw',
                              dm: '回退',
                            })}
                          </Tag>
                          {/* <span className="progress-content-text">
                            {versionDetail?.approveOpinion}
                          </span> */}
                        </>
                      ) : (
                        <>
                          <div className="progress-dec">
                            {$i18n.get({
                              id: 'aopf.pages.miniapp.version.info.process.Review.Application',
                              dm: '审查申请',
                            })}
                          </div>
                          <Tag data-square color="#FFF2F2" className="tag-refused">
                            {$i18n.get({
                              id: 'aopf.pages.miniapp.version.info.process.Refused',
                              dm: '拒绝',
                            })}
                          </Tag>
                          <span className="progress-content-text">
                            {versionDetail?.approveOpinion
                              ? versionDetail?.approveOpinion
                              : $i18n.get({
                                  id: 'aopf.pages.miniapp.version.info.process.No.Reason',
                                  dm: '拒绝',
                                })}
                          </span>
                        </>
                      )}
                    </div>
                  }
                />
              ) : (
                <></>
              )}
            </Timeline>
            {versionDetail?.status === 'PROCESSING' && (
              <Button
                className="progress-withdraw"
                type="primary"
                onClick={() => setIsModalVisible(true)}
              >
                {$i18n.get({
                  id: 'aopf.pages.miniapp.version.info.process.Withdraw',
                  dm: '回退',
                })}
              </Button>
            )}
          </div>
          <div className="appInfo-container">
            <div className="appInfo-logo">
              {versionDetail?.extInfo?.description?.iconPublicUrl ? (
                <img className="logo" src={versionDetail?.extInfo?.description?.iconPublicUrl} />
              ) : (
                <DefaultAppIcon className="logo" />
              )}
              
              <QRCode url={versionDetail?.extInfo?.version?.previewUrl} />
            </div>
            <div className="info-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.App.information',
                dm: '应用程序信息',
              })}
            </div>

            <Row wrap={false}>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="mobile--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.Miniapp.Name',
                      dm: 'Miniapp名称',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">
                <div className="info-dec">{versionDetail?.extInfo?.description?.name}</div>
              </Col>
            </Row>
            <Row wrap={false}>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="apps--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.Type',
                      dm: '类型',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">{versionDetail?.extInfo?.app?.framework}</Col>
            </Row>
            <Row>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="user--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.process.Creator',
                      dm: '作者',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">{versionDetail?.extInfo?.description?.createName}</Col>
            </Row>
            {/* <Row>
                  <Col flex="160px">
                    <div className="info-item">
                      <div className="info-icon">
                        <Icon type="gongwenbao_xianxing" size="xs" />
                      </div>
                      <div>
                        {$i18n.get({
                          id: 'aopf.pages.miniapp.version.info.process.Category',
                          dm: '类别',
                        })}
                      </div>
                    </div>
                  </Col>
                  <Col flex="auto">
                    <div className="info-dec">{versionDetail?.extInfo?.description?.category}</div>
                  </Col>
                </Row> */}
            <Row wrap={false}>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="wikis--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.Slogan',
                      dm: '标语',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">
                <div className="info-dec">{versionDetail?.extInfo?.description?.slogan}</div>
              </Col>
            </Row>
            <Row wrap={false}>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="document--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.Description',
                      dm: '描述',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">
                <Popover
                  align="t"
                  v2
                  trigger={
                    <div className="info-description">
                      {versionDetail?.extInfo?.description?.description}
                    </div>
                  }
                  closable={false}
                >
                  <div className="text-breakWord">
                    {versionDetail?.extInfo?.description?.description}
                  </div>
                </Popover>
              </Col>
            </Row>
            <div className="info-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Version.information',
                dm: '版本信息',
              })}
            </div>
            <Row>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="package--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.Version',
                      dm: '版本',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">v{versionDetail?.extInfo?.description?.version}</Col>
            </Row>
            <Row>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="equipment--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.process.Channel',
                      dm: '渠道',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">{versionDetail?.extInfo?.version?.channelName}</Col>
            </Row>
            <Row>
              <Col flex="160px">
                <div className="info-item">
                  <div className="info-icon">
                    <Icon type="folder--details--outline" size="xs" />
                  </div>
                  <div>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.Release.Note',
                      dm: '发布说明',
                    })}
                  </div>
                </div>
              </Col>
              <Col flex="auto">
                <Popover
                  align="t"
                  v2
                  trigger={
                    <div className="info-releaseNote">
                      {versionDetail?.extInfo?.version?.changelog}
                    </div>
                  }
                  closable={false}
                >
                  <div className="text-breakWord">{versionDetail?.extInfo?.version?.changelog}</div>
                </Popover>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <Modal
        title={$i18n.get({
          id: 'aopf.pages.miniapp.version.info.process.Withdraw',
          dm: '回退',
        })}
        data-size="xs"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={() => setIsModalVisible(false)}
        closeMode={['close', 'esc', 'mask']}
        onClose={() => setIsModalVisible(false)}
        footer={
          <div>
            <Button onClick={() => setIsModalVisible(false)}>
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.confirm.Cancel',
                dm: '取消',
              })}
            </Button>
            <Button type="primary" onClick={handleOk} className="marginLeft-8">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.confirm.Ok',
                dm: '确定',
              })}
            </Button>
          </div>
        }
      >
        <div className="marginTop-30">
          {$i18n.get({
            id: 'aopf.pages.miniapp.version.info.process.Withdraw.Content',
            dm: '回退内容',
          })}
        </div>
      </Modal>
    </div>
  );
};
export default ReleaseResult;
